import React from 'react';
import { Stack, Text, Link, FontWeights, IStackTokens, IStackStyles, ITextStyles, LayerHost } from '@fluentui/react';
import logo from './logo.svg';
import './App.css';
import {PageLayout} from './components/Layout';
import { GlobalStateProvider } from "./utils/GlobalState";

const boldStyle: Partial<ITextStyles> = { root: { fontWeight: FontWeights.semibold } };
const stackTokens: IStackTokens = { childrenGap: 15 };
const stackStyles: Partial<IStackStyles> = {
  root: {
    width: '960px',
    margin: '0 auto',
    textAlign: 'center',
    color: '#605e5c',
  },
};

export const App: React.FunctionComponent = () => {
  return (
    <GlobalStateProvider>
      <PageLayout />
    </GlobalStateProvider>    
  );
};
